export const exanteMetricsBlockBaseQueryKey = "Exante H Metrics";
